import OrderItemsDB, { OrderItemEntity } from 'src/firebase/db/OrderItems';

export const getOrderItems = (orderBreadId: string) => {
  return OrderItemsDB.getOrderItems(orderBreadId);
};

export const createOrderItem = (query: OrderItemEntity) => OrderItemsDB.create(query);
